import { C } from "../customers/theme";

/**
 * A consistent friendly empty-state panel: icon + title + one-line message + an optional
 * primary action node. Presentational only — used across list screens and first-run flows.
 */
export default function EmptyState({ icon = "✨", title, message, action, compact = false }) {
  return (
    <div style={{ textAlign: "center", padding: compact ? "16px 12px" : "34px 16px", color: C.textMuted }}>
      {icon && <div style={{ fontSize: 32, marginBottom: 8 }}>{icon}</div>}
      {title && <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 4 }}>{title}</div>}
      {message && <div style={{ fontSize: 13, lineHeight: 1.5, maxWidth: 440, margin: "0 auto 14px" }}>{message}</div>}
      {action}
    </div>
  );
}
